import React, {useState} from 'react' 
import { Card, Button, Input, Header, Footer, Notification} from '@scuf/common' //, ToastNotification
import { useHistory } from "react-router-dom"
import { useDispatch } from 'react-redux'

import { login } from '../../actions/authLogin'
import { msgError, removeError } from '../../actions/msgError'
import servicesAuth from '../../services/auth.services'

import '@scuf/common/honeywell-compact-combined/theme.css'
import './Init.scss'
import 'react-toastify/dist/ReactToastify.css';
import UseIconCompany from '../../customHook/useIconCompany'
import baseServices from '../../services/base.services'

const ReactToastify = import('react-toastify')

const InitPage = () => {

    localStorage.removeItem('reduxState');
    const dispatch = useDispatch();

    var logo = 'https://www.honeywell.com/content/dam/honeywell/en-us/images/HON%20logo_200x37.png';

    const [user, setUser] = useState('')
    const [rut, setRut] = useState('')   
    const [pass, setPass] = useState('')  
    const [load, setLoad] = useState(false);
    const [error, setError] = useState(null);

    let history = useHistory();
    
    const getData = async (e: any) => {
        e.preventDefault()
        setLoad(true);
        await baseServices.getEmpleyoee({rut: user}).then(
            (response) => {
                console.log(response);
                setLoad(false);
                if(response.data.length > 0){
                    localStorage.setItem('user', JSON.stringify({data: {Username: response.data[0].name, name: response.data[0].name, lastname: response.data[0].lastname, 
                        rut: response.data[0].rut, isAdmin: false}}))
                    history.push('/home')
                }else{
                    {/*@ts-ignore */}
                    setError("No hay usuarios con el RUT ingresado");
                }

            },
            (error) => {
                console.log(error);
                setLoad(false);
            });
    };



    const formatedRut = (_rut: any, $event: any) => {
        
        if (_rut) {
            var rut = formatRut(_rut, $event);
            console.log(rut);
            setUser(rut)
            return 
        } else {
          return null;
        }
      }
    
    const formatRut = (texto: any, event: any) => {
        if (
          event &&
          event.type != 'blur' &&
          event.code != 'Enter' &&
          event.code != '13' &&
          event.code != 13 &&
          event.charCode != '13' &&
          event.charCode != 13
        )
          return texto;
    
        if (texto === null || texto === undefined) return null;
        var size = texto.length;
        if (size == 1) return texto;
    
        //console.log('Antes: ' + texto);
        //si tiene puntos (.) o guiones (-) se los saca
        texto = (texto.slice(0, size - 1).replace(/[^\d]/gi, '') + texto.slice(size - 1).replace(/[^\d^k]/gi, '')).replace(
          /^[0]*/g,
          ''
        );
        //console.log('Después: ' + texto);
    
        var number = texto.substring(0, texto.length - 1);
        var dv = texto.substring(texto.length - 1);
        //agrega los puntos (.) y el guión (-)
        var rut =
          number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, function($1: any) {
            return $1 + '.';
          }) +
          '-' +
          dv;
        //console.log(rut);
    
        return rut;
      }
    

    return (
        <>
            <div className="login-page" />
            <div className='mx-auto'>
                <Card> 
                    {/*// @ts-ignore */}
                    <div className='header-absolute'>
                        {/* @ts-ignore */}
                        <Header className='header-absolute' isForge={true} title={<UseIconCompany callback={null}></UseIconCompany>}>
                        </Header>
                    </div>
                    <Card.Content className='content-black'>
                        <form>
                        <h5  className='mb-3 text-center'>Libro sugerencias paritario</h5 >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {/* @ts-ignore*/}
                            <Input onBlur={(e: any, d:any) => formatedRut(user, d)}
                                 
                                className="input-custom" 
                                placeholder="Ingrese.." 
                                label="RUT"
                                value={user}
                                onChange={e => setUser(e)} 
                                type="text"
                                fluid={true}
                                onFocus={()=> setError(null)}
                            />
                            { error == null ?<br></br> :
                            <Notification
                                hasIcon={true}
                                severity="critical">
                                {error}
                            </Notification>
                            }
                            <Button type="primary"
                            
                                style={{ marginTop: '10px' }}
                                disabled={load}
                                onClick={getData}
                                content="Login" 
                                actionType="submit"
                                loading={load}
                            />
                        </div>
                        </form>
                    </Card.Content>
                    <Footer copyrightText="Powered by Kairos Mining" style={{ display: 'none' }}>
                        <Footer.Item href="#" >
                            <img 
                                src={logo} 
                                alt="Logo" 
                                style={{ width: '80px', marginRight: '120px' }} 
                            />  
                        </Footer.Item>
                    </Footer>
                </Card>
            </div>
            
            {
               // toast()
            }
            
        </>
    )
}

export default InitPage
